/* import __COLOCATED_TEMPLATE__ from './signup-form.hbs'; */
import Component from '@ember/component';

/** @class */
const SignupForm = Component.extend({

  /** @inheritDoc */
  tagName: 'form',

  /** @inheritDoc */
  classNames: ['signup-form'],

  /** @inheritDoc */
  attributeBindings: ['novalidate', 'disabled', 'autocomplete'],

  /** @type {boolean} */
  novalidate: true,

  /** @type {boolean} */
  disabled: false,

  /** @type {string} */
  autocomplete: 'off',

  /** @inheritDoc */
  submit(e) {
    e.preventDefault();

    this.get('onsubmit')();
  },

  /** @type {function} */
  onsubmit: () => { },
});

export default SignupForm;
